// extracted by mini-css-extract-plugin
export default {"fileSelectInput":"CauWE9GTZ0s2686t4nAV"};